var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LogOutSvg from './log-out-01.icon.svg';
export const LogOutIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LogOutSvg }));
_react_refresh_temp_1 = LogOutIcon;
$RefreshReg$(_react_refresh_temp_1, "LogOutIcon");
